<template>
  <div class="shop-cart-discount">
    <div class="shop-cart-discount__title">
      {{ useTranslation('general', 'discounts_and_bons') }}
    </div>
    <form
      type="submit"
      class="shop-cart-discount__form"
      @submit.prevent="setDiscount"
    >
      <FormInputText
        class="shop-cart-discount__input"
        :data="{
          is_required: false,
          field_key: 'discount_code',
          label: useTranslation('general', 'enter_code'),
        }"
        @emit-value="setValue"
      />

      <AtomButton
        :text="useTranslation('general', 'redeem')"
        @click="setDiscount"
      />
    </form>
  </div>
</template>

<script setup>

const currentCode = ref('');
const setValue = (data) => {
    currentCode.value = data.value;
};

const cartStore = useCartStore();
const alertBoxStore = useAlertBoxStore();
const setDiscount = async () => {
    try {
        await cartStore.addDiscountToCart(currentCode.value);
        const checkoutStore = useCheckoutStore();
        checkoutStore.setDiscount(currentCode.value);

        alertBoxStore.setAlertBoxData('success', {
            success_text: useTranslation('general', 'add_discount_success_message'),
        });
        alertBoxStore.toggleAlertbox();
    } catch (e) {
        alertBoxStore.setAlertBoxData('error', {
            error_text: useTranslation('general', 'add_discount_error_message'),
        });
        alertBoxStore.toggleAlertbox();
        useSentryError(e);
    }
};
</script>

<style lang="scss" scoped>
.shop-cart-discount {
    @include fluid('margin-bottom', 40px, 50px);
    max-width: 500px;
}

.shop-cart-discount__form {
    display: flex;
    column-gap: 30px;

    @include mobile {
        flex-direction: column;
        align-items: flex-start
    }
}

.shop-cart-discount__title {
    @include fluid('font-size', 22px, 26px);
    @include typo-font('regular');
    @include fluid('margin-bottom', 10px, 20px);
    color: $C_GREEN_DARK;
}

.shop-cart-discount__input {
    width: 100%;

    @include mobile {
        margin-bottom: 10px
    }
}
</style>
